import React, { Component } from 'react';

export default class Header extends Component {

    render() {
        return (
            <>
                <footer>
                    <div className="footer">
                        By using Smelt-It, you are providing Environment Canterbury with personal information including your name, contact information, location and digital device.  We use that information to assess and identify odour issues and to provide information to you.

                        Providing some information is optional – though if you choose not to provide your name and contact information, we will not be able to provide updates and further information.

                        Please note you have the right to ask for a copy of any personal information we hold about you, and for it to be corrected if necessary. You can request your information and ask to have it corrected by contacting <a href="mailto:ecinfo@ecan.govt.nz">ecinfo@ecan.govt.nz</a> or calling <a href="tel:0800324636">0800 324 636</a>.
                    </div>
                </footer>
            </>
        )
    }
}